export default __webpack_public_path__ + "2a1d5c8034d6ff07e77138fd7e87ec10.png";